
var Rive = (() => {
  var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
  
  return (
function(moduleArg = {}) {
  var moduleRtn;

var k = moduleArg, aa, ba, ca = new Promise((b, a) => {
  aa = b;
  ba = a;
}), da = "object" == typeof window, ea = "function" == typeof importScripts;
function ja() {
  function b(m) {
    const h = d;
    c = a = 0;
    d = new Map();
    h.forEach(l => {
      try {
        l(m);
      } catch (n) {
        console.error(n);
      }
    });
    this.va();
    e && e.Pa();
  }
  let a = 0, c = 0, d = new Map(), e = null, f = null;
  this.requestAnimationFrame = function(m) {
    a ||= requestAnimationFrame(b.bind(this));
    const h = ++c;
    d.set(h, m);
    return h;
  };
  this.cancelAnimationFrame = function(m) {
    d.delete(m);
    a && 0 == d.size && (cancelAnimationFrame(a), a = 0);
  };
  this.Na = function(m) {
    f && (document.body.remove(f), f = null);
    m || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", m = function(h) {
      f.innerHTML = "RIVE FPS " + h.toFixed(1);
    }, document.body.appendChild(f));
    e = new function() {
      let h = 0, l = 0;
      this.Pa = function() {
        var n = performance.now();
        l ? (++h, n -= l, 1000 < n && (m(1000 * h / n), h = l = 0)) : (l = n, h = 0);
      };
    }();
  };
  this.Ka = function() {
    f && (document.body.remove(f), f = null);
    e = null;
  };
  this.va = function() {
  };
}
function ka(b) {
  console.assert(!0);
  const a = new Map();
  let c = -Infinity;
  this.push = function(d) {
    d = d + ((1 << b) - 1) >> b;
    a.has(d) && clearTimeout(a.get(d));
    a.set(d, setTimeout(function() {
      a.delete(d);
      0 == a.length ? c = -Infinity : d == c && (c = Math.max(...a.keys()), console.assert(c < d));
    }, 1000));
    c = Math.max(d, c);
    return c << b;
  };
}
const la = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  la && la();
  let b = k.decodeAudio;
  k.decodeAudio = function(e, f) {
    e = b(e);
    f(e);
  };
  let a = k.decodeFont;
  k.decodeFont = function(e, f) {
    e = a(e);
    f(e);
  };
  const c = k.FileAssetLoader;
  k.ptrToAsset = e => {
    let f = k.ptrToFileAsset(e);
    return f.isImage ? k.ptrToImageAsset(e) : f.isFont ? k.ptrToFontAsset(e) : f.isAudio ? k.ptrToAudioAsset(e) : f;
  };
  k.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {__construct:function({loadContents:e}) {
    this.__parent.__construct.call(this);
    this.Ea = e;
  }, loadContents:function(e, f) {
    e = k.ptrToAsset(e);
    return this.Ea(e, f);
  },});
  k.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
  }, loadContents:function(e) {
    let f = k.ptrToAsset(e);
    e = f.cdnUuid;
    if ("" === e) {
      return !1;
    }
    (function(m, h) {
      var l = new XMLHttpRequest();
      l.responseType = "arraybuffer";
      l.onreadystatechange = function() {
        4 == l.readyState && 200 == l.status && h(l);
      };
      l.open("GET", m, !0);
      l.send(null);
    })(f.cdnBaseUrl + "/" + e, m => {
      f.decode(new Uint8Array(m.response));
    });
    return !0;
  },});
  k.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
    this.ua = [];
  }, addLoader:function(e) {
    this.ua.push(e);
  }, loadContents:function(e, f) {
    for (let m of this.ua) {
      if (m.loadContents(e, f)) {
        return !0;
      }
    }
    return !1;
  },});
  let d = k.computeAlignment;
  k.computeAlignment = function(e, f, m, h, l = 1.0) {
    return d.call(this, e, f, m, h, l);
  };
};
const oa = "createConicGradient createImageData createLinearGradient createPattern createRadialGradient getContextAttributes getImageData getLineDash getTransform isContextLost isPointInPath isPointInStroke measureText".split(" "), pa = new function() {
  function b() {
    if (!a) {
      var g = document.createElement("canvas"), t = {alpha:1, depth:0, stencil:0, antialias:0, premultipliedAlpha:1, preserveDrawingBuffer:0, powerPreference:"high-performance", failIfMajorPerformanceCaveat:0, enableExtensionsByDefault:1, explicitSwapControl:1, renderViaOffscreenBackBuffer:1,};
      let q;
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        if (q = g.getContext("webgl", t), c = 1, !q) {
          return console.log("No WebGL support. Image mesh will not be drawn."), !1;
        }
      } else {
        if (q = g.getContext("webgl2", t)) {
          c = 2;
        } else {
          if (q = g.getContext("webgl", t)) {
            c = 1;
          } else {
            return console.log("No WebGL support. Image mesh will not be drawn."), !1;
          }
        }
      }
      q = new Proxy(q, {get(E, v) {
        if (E.isContextLost()) {
          if (l || (console.error("Cannot render the mesh because the GL Context was lost. Tried to invoke ", v), l = !0), "function" === typeof E[v]) {
            return function() {
            };
          }
        } else {
          return "function" === typeof E[v] ? function(...I) {
            return E[v].apply(E, I);
          } : E[v];
        }
      }, set(E, v, I) {
        if (E.isContextLost()) {
          l || (console.error("Cannot render the mesh because the GL Context was lost. Tried to set property " + v), l = !0);
        } else {
          return E[v] = I, !0;
        }
      },});
      d = Math.min(q.getParameter(q.MAX_RENDERBUFFER_SIZE), q.getParameter(q.MAX_TEXTURE_SIZE));
      function F(E, v, I) {
        v = q.createShader(v);
        q.shaderSource(v, I);
        q.compileShader(v);
        I = q.getShaderInfoLog(v);
        if (0 < (I || "").length) {
          throw I;
        }
        q.attachShader(E, v);
      }
      g = q.createProgram();
      F(g, q.VERTEX_SHADER, "attribute vec2 vertex;\n                attribute vec2 uv;\n                uniform vec4 mat;\n                uniform vec2 translate;\n                varying vec2 st;\n                void main() {\n                    st = uv;\n                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);\n                }");
      F(g, q.FRAGMENT_SHADER, "precision highp float;\n                uniform sampler2D image;\n                varying vec2 st;\n                void main() {\n                    gl_FragColor = texture2D(image, st);\n                }");
      q.bindAttribLocation(g, 0, "vertex");
      q.bindAttribLocation(g, 1, "uv");
      q.linkProgram(g);
      t = q.getProgramInfoLog(g);
      if (0 < (t || "").trim().length) {
        throw t;
      }
      e = q.getUniformLocation(g, "mat");
      f = q.getUniformLocation(g, "translate");
      q.useProgram(g);
      q.bindBuffer(q.ARRAY_BUFFER, q.createBuffer());
      q.enableVertexAttribArray(0);
      q.enableVertexAttribArray(1);
      q.bindBuffer(q.ELEMENT_ARRAY_BUFFER, q.createBuffer());
      q.uniform1i(q.getUniformLocation(g, "image"), 0);
      q.pixelStorei(q.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
      a = q;
    }
    return !0;
  }
  let a = null, c = 0, d = 0, e = null, f = null, m = 0, h = 0, l = !1;
  b();
  this.Xa = function() {
    b();
    return d;
  };
  this.Ja = function(g) {
    a.deleteTexture && a.deleteTexture(g);
  };
  this.Ia = function(g) {
    if (!b()) {
      return null;
    }
    const t = a.createTexture();
    if (!t) {
      return null;
    }
    a.bindTexture(a.TEXTURE_2D, t);
    a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, g);
    a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE);
    a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE);
    a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.LINEAR);
    2 == c ? (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR_MIPMAP_LINEAR), a.generateMipmap(a.TEXTURE_2D)) : a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR);
    return t;
  };
  const n = new ka(8), r = new ka(8), w = new ka(10), y = new ka(10);
  this.Ma = function(g, t, q, F, E) {
    if (b()) {
      var v = n.push(g), I = r.push(t);
      if (a.canvas) {
        if (a.canvas.width != v || a.canvas.height != I) {
          a.canvas.width = v, a.canvas.height = I;
        }
        a.viewport(0, I - t, g, t);
        a.disable(a.SCISSOR_TEST);
        a.clearColor(0, 0, 0, 0);
        a.clear(a.COLOR_BUFFER_BIT);
        a.enable(a.SCISSOR_TEST);
        q.sort((D, V) => V.ya - D.ya);
        v = w.push(F);
        m != v && (a.bufferData(a.ARRAY_BUFFER, 8 * v, a.DYNAMIC_DRAW), m = v);
        v = 0;
        for (var N of q) {
          a.bufferSubData(a.ARRAY_BUFFER, v, N.ia), v += 4 * N.ia.length;
        }
        console.assert(v == 4 * F);
        for (var R of q) {
          a.bufferSubData(a.ARRAY_BUFFER, v, R.Ba), v += 4 * R.Ba.length;
        }
        console.assert(v == 8 * F);
        v = y.push(E);
        h != v && (a.bufferData(a.ELEMENT_ARRAY_BUFFER, 2 * v, a.DYNAMIC_DRAW), h = v);
        N = 0;
        for (var fa of q) {
          a.bufferSubData(a.ELEMENT_ARRAY_BUFFER, N, fa.indices), N += 2 * fa.indices.length;
        }
        console.assert(N == 2 * E);
        fa = 0;
        R = !0;
        v = N = 0;
        for (const D of q) {
          D.image.da != fa && (a.bindTexture(a.TEXTURE_2D, D.image.ca || null), fa = D.image.da);
          D.$a ? (a.scissor(D.na, I - D.oa - D.ta, D.lb, D.ta), R = !0) : R && (a.scissor(0, I - t, g, t), R = !1);
          q = 2 / g;
          const V = -2 / t;
          a.uniform4f(e, D.N[0] * q * D.X, D.N[1] * V * D.Y, D.N[2] * q * D.X, D.N[3] * V * D.Y);
          a.uniform2f(f, D.N[4] * q * D.X + q * (D.na - D.Ya * D.X) - 1, D.N[5] * V * D.Y + V * (D.oa - D.Za * D.Y) + 1);
          a.vertexAttribPointer(0, 2, a.FLOAT, !1, 0, v);
          a.vertexAttribPointer(1, 2, a.FLOAT, !1, 0, v + 4 * F);
          a.drawElements(a.TRIANGLES, D.indices.length, a.UNSIGNED_SHORT, N);
          v += 4 * D.ia.length;
          N += 2 * D.indices.length;
        }
        console.assert(v == 4 * F);
        console.assert(N == 2 * E);
      }
    }
  };
  this.canvas = function() {
    return b() && a.canvas;
  };
}(), qa = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  function b(p) {
    switch(p) {
      case n.srcOver:
        return "source-over";
      case n.screen:
        return "screen";
      case n.overlay:
        return "overlay";
      case n.darken:
        return "darken";
      case n.lighten:
        return "lighten";
      case n.colorDodge:
        return "color-dodge";
      case n.colorBurn:
        return "color-burn";
      case n.hardLight:
        return "hard-light";
      case n.softLight:
        return "soft-light";
      case n.difference:
        return "difference";
      case n.exclusion:
        return "exclusion";
      case n.multiply:
        return "multiply";
      case n.hue:
        return "hue";
      case n.saturation:
        return "saturation";
      case n.color:
        return "color";
      case n.luminosity:
        return "luminosity";
    }
  }
  function a(p) {
    return "rgba(" + ((16711680 & p) >>> 16) + "," + ((65280 & p) >>> 8) + "," + ((255 & p) >>> 0) + "," + ((4278190080 & p) >>> 24) / 255 + ")";
  }
  function c() {
    0 < I.length && (pa.Ma(v.drawWidth(), v.drawHeight(), I, N, R), I = [], R = N = 0, v.reset(512, 512));
    for (const p of E) {
      for (const u of p.v) {
        u();
      }
      p.v = [];
    }
    E.clear();
  }
  qa && qa();
  var d = k.RenderPaintStyle;
  const e = k.RenderPath, f = k.RenderPaint, m = k.Renderer, h = k.StrokeCap, l = k.StrokeJoin, n = k.BlendMode, r = d.fill, w = d.stroke, y = k.FillRule.evenOdd;
  let g = 1;
  var t = k.RenderImage.extend("CanvasRenderImage", {__construct:function({R:p, W:u} = {}) {
    this.__parent.__construct.call(this);
    this.da = g;
    g = g + 1 & 2147483647 || 1;
    this.R = p;
    this.W = u;
  }, __destruct:function() {
    this.ca && (pa.Ja(this.ca), URL.revokeObjectURL(this.la));
    this.__parent.__destruct.call(this);
  }, decode:function(p) {
    var u = this;
    u.W && u.W(u);
    var B = new Image();
    u.la = URL.createObjectURL(new Blob([p], {type:"image/png",}));
    B.onload = function() {
      u.Da = B;
      u.ca = pa.Ia(B);
      u.size(B.width, B.height);
      u.R && u.R(u);
    };
    B.src = u.la;
  },}), q = e.extend("CanvasRenderPath", {__construct:function() {
    this.__parent.__construct.call(this);
    this.H = new Path2D();
  }, rewind:function() {
    this.H = new Path2D();
  }, addPath:function(p, u, B, z, G, C, A) {
    var H = this.H, W = H.addPath;
    p = p.H;
    const L = new DOMMatrix();
    L.a = u;
    L.b = B;
    L.c = z;
    L.d = G;
    L.e = C;
    L.f = A;
    W.call(H, p, L);
  }, fillRule:function(p) {
    this.ka = p;
  }, moveTo:function(p, u) {
    this.H.moveTo(p, u);
  }, lineTo:function(p, u) {
    this.H.lineTo(p, u);
  }, cubicTo:function(p, u, B, z, G, C) {
    this.H.bezierCurveTo(p, u, B, z, G, C);
  }, close:function() {
    this.H.closePath();
  },}), F = f.extend("CanvasRenderPaint", {color:function(p) {
    this.ma = a(p);
  }, thickness:function(p) {
    this.Ga = p;
  }, join:function(p) {
    switch(p) {
      case l.miter:
        this.ba = "miter";
        break;
      case l.round:
        this.ba = "round";
        break;
      case l.bevel:
        this.ba = "bevel";
    }
  }, cap:function(p) {
    switch(p) {
      case h.butt:
        this.aa = "butt";
        break;
      case h.round:
        this.aa = "round";
        break;
      case h.square:
        this.aa = "square";
    }
  }, style:function(p) {
    this.Fa = p;
  }, blendMode:function(p) {
    this.Ca = b(p);
  }, clearGradient:function() {
    this.P = null;
  }, linearGradient:function(p, u, B, z) {
    this.P = {za:p, Aa:u, qa:B, ra:z, ga:[],};
  }, radialGradient:function(p, u, B, z) {
    this.P = {za:p, Aa:u, qa:B, ra:z, ga:[], Wa:!0,};
  }, addStop:function(p, u) {
    this.P.ga.push({color:p, stop:u,});
  }, completeGradient:function() {
  }, draw:function(p, u, B, z) {
    let G = this.Fa;
    var C = this.ma, A = this.P;
    const H = p.globalCompositeOperation, W = p.globalAlpha;
    p.globalCompositeOperation = this.Ca;
    p.globalAlpha = z;
    if (null != A) {
      C = A.za;
      const S = A.Aa, M = A.qa;
      var L = A.ra;
      z = A.ga;
      A.Wa ? (A = M - C, L -= S, C = p.createRadialGradient(C, S, 0, C, S, Math.sqrt(A * A + L * L))) : C = p.createLinearGradient(C, S, M, L);
      for (let ma = 0, Ha = z.length; ma < Ha; ma++) {
        A = z[ma], C.addColorStop(A.stop, a(A.color));
      }
      this.ma = C;
      this.P = null;
    }
    switch(G) {
      case w:
        p.strokeStyle = C;
        p.lineWidth = this.Ga;
        p.lineCap = this.aa;
        p.lineJoin = this.ba;
        p.stroke(u);
        break;
      case r:
        p.fillStyle = C, p.fill(u, B);
    }
    p.globalCompositeOperation = H;
    p.globalAlpha = W;
  },});
  const E = new Set();
  let v = null, I = [], N = 0, R = 0;
  var fa = k.CanvasRenderer = m.extend("Renderer", {__construct:function(p) {
    this.__parent.__construct.call(this);
    this.G = [1, 0, 0, 1, 0, 0];
    this.u = [1.0];
    this.m = p.getContext("2d");
    this.ja = p;
    this.v = [];
  }, save:function() {
    this.G.push(...this.G.slice(this.G.length - 6));
    this.u.push(this.u[this.u.length - 1]);
    this.v.push(this.m.save.bind(this.m));
  }, restore:function() {
    const p = this.G.length - 6;
    if (6 > p) {
      throw "restore() called without matching save().";
    }
    this.G.splice(p);
    this.u.pop();
    this.v.push(this.m.restore.bind(this.m));
  }, transform:function(p, u, B, z, G, C) {
    const A = this.G, H = A.length - 6;
    A.splice(H, 6, A[H] * p + A[H + 2] * u, A[H + 1] * p + A[H + 3] * u, A[H] * B + A[H + 2] * z, A[H + 1] * B + A[H + 3] * z, A[H] * G + A[H + 2] * C + A[H + 4], A[H + 1] * G + A[H + 3] * C + A[H + 5]);
    this.v.push(this.m.transform.bind(this.m, p, u, B, z, G, C));
  }, rotate:function(p) {
    const u = Math.sin(p);
    p = Math.cos(p);
    this.transform(p, u, -u, p, 0, 0);
  }, modulateOpacity:function(p) {
    this.u[this.u.length - 1] *= p;
  }, _drawPath:function(p, u) {
    this.v.push(u.draw.bind(u, this.m, p.H, p.ka === y ? "evenodd" : "nonzero", Math.max(0, this.u[this.u.length - 1])));
  }, _drawRiveImage:function(p, u, B, z) {
    var G = p.Da;
    if (G) {
      var C = this.m, A = b(B), H = Math.max(0, z * this.u[this.u.length - 1]);
      this.v.push(function() {
        C.globalCompositeOperation = A;
        C.globalAlpha = H;
        C.drawImage(G, 0, 0);
        C.globalAlpha = 1;
      });
    }
  }, _getMatrix:function(p) {
    const u = this.G, B = u.length - 6;
    for (let z = 0; 6 > z; ++z) {
      p[z] = u[B + z];
    }
  }, _drawImageMesh:function(p, u, B, z, G, C, A, H, W, L, S) {
    u = this.m.canvas.width;
    var M = this.m.canvas.height;
    const ma = L - H, Ha = S - W;
    H = Math.max(H, 0);
    W = Math.max(W, 0);
    L = Math.min(L, u);
    S = Math.min(S, M);
    const ua = L - H, va = S - W;
    console.assert(ua <= Math.min(ma, u));
    console.assert(va <= Math.min(Ha, M));
    if (!(0 >= ua || 0 >= va)) {
      L = ua < ma || va < Ha;
      u = S = 1;
      var ha = Math.ceil(ua * S), ia = Math.ceil(va * u);
      M = pa.Xa();
      ha > M && (S *= M / ha, ha = M);
      ia > M && (u *= M / ia, ia = M);
      v || (v = new k.DynamicRectanizer(M), v.reset(512, 512));
      M = v.addRect(ha, ia);
      0 > M && (c(), E.add(this), M = v.addRect(ha, ia), console.assert(0 <= M));
      var tb = M & 65535, ub = M >> 16;
      I.push({N:this.G.slice(this.G.length - 6), image:p, na:tb, oa:ub, Ya:H, Za:W, lb:ha, ta:ia, X:S, Y:u, ia:new Float32Array(G), Ba:new Float32Array(C), indices:new Uint16Array(A), $a:L, ya:p.da << 1 | (L ? 1 : 0),});
      N += G.length;
      R += A.length;
      var na = this.m, lc = b(B), mc = Math.max(0, z * this.u[this.u.length - 1]);
      this.v.push(function() {
        na.save();
        na.resetTransform();
        na.globalCompositeOperation = lc;
        na.globalAlpha = mc;
        const vb = pa.canvas();
        vb && na.drawImage(vb, tb, ub, ha, ia, H, W, ua, va);
        na.restore();
      });
    }
  }, _clipPath:function(p) {
    this.v.push(this.m.clip.bind(this.m, p.H, p.ka === y ? "evenodd" : "nonzero"));
  }, clear:function() {
    E.add(this);
    this.v.push(this.m.clearRect.bind(this.m, 0, 0, this.ja.width, this.ja.height));
  }, flush:function() {
  }, translate:function(p, u) {
    this.transform(1, 0, 0, 1, p, u);
  },});
  k.makeRenderer = function(p) {
    const u = new fa(p), B = u.m;
    return new Proxy(u, {get(z, G) {
      if ("function" === typeof z[G]) {
        return function(...C) {
          return z[G].apply(z, C);
        };
      }
      if ("function" === typeof B[G]) {
        if (-1 < oa.indexOf(G)) {
          throw Error("RiveException: Method call to '" + G + "()' is not allowed, as the renderer cannot immediately pass through the return                 values of any canvas 2d context methods.");
        }
        return function(...C) {
          u.v.push(B[G].bind(B, ...C));
        };
      }
      return z[G];
    }, set(z, G, C) {
      if (G in B) {
        return u.v.push(() => {
          B[G] = C;
        }), !0;
      }
    },});
  };
  k.decodeImage = function(p, u) {
    (new t({R:u})).decode(p);
  };
  k.renderFactory = {makeRenderPaint:function() {
    return new F();
  }, makeRenderPath:function() {
    return new q();
  }, makeRenderImage:function() {
    let p = V;
    return new t({W:() => {
      p.total++;
    }, R:() => {
      p.loaded++;
      if (p.loaded === p.total) {
        const u = p.ready;
        u && (u(), p.ready = null);
      }
    },});
  },};
  let D = k.load, V = null;
  k.load = function(p, u, B = !0) {
    const z = new k.FallbackFileAssetLoader();
    void 0 !== u && z.addLoader(u);
    B && (u = new k.CDNFileAssetLoader(), z.addLoader(u));
    return new Promise(function(G) {
      let C = null;
      V = {total:0, loaded:0, ready:function() {
        G(C);
      },};
      C = D(p, z);
      0 == V.total && G(C);
    });
  };
  let nc = k.RendererWrapper.prototype.align;
  k.RendererWrapper.prototype.align = function(p, u, B, z, G = 1.0) {
    nc.call(this, p, u, B, z, G);
  };
  d = new ja();
  k.requestAnimationFrame = d.requestAnimationFrame.bind(d);
  k.cancelAnimationFrame = d.cancelAnimationFrame.bind(d);
  k.enableFPSCounter = d.Na.bind(d);
  k.disableFPSCounter = d.Ka;
  d.va = c;
  k.resolveAnimationFrame = c;
  k.cleanup = function() {
    v && v.delete();
  };
};
var ra = Object.assign({}, k), sa = "./this.program", x = "", ta, wa;
if (da || ea) {
  ea ? x = self.location.href : "undefined" != typeof document && document.currentScript && (x = document.currentScript.src), _scriptName && (x = _scriptName), x.startsWith("blob:") ? x = "" : x = x.substr(0, x.replace(/[?#].*/, "").lastIndexOf("/") + 1), ea && (wa = b => {
    var a = new XMLHttpRequest();
    a.open("GET", b, !1);
    a.responseType = "arraybuffer";
    a.send(null);
    return new Uint8Array(a.response);
  }), ta = (b, a, c) => {
    if (xa(b)) {
      var d = new XMLHttpRequest();
      d.open("GET", b, !0);
      d.responseType = "arraybuffer";
      d.onload = () => {
        200 == d.status || 0 == d.status && d.response ? a(d.response) : c();
      };
      d.onerror = c;
      d.send(null);
    } else {
      fetch(b, {credentials:"same-origin"}).then(e => e.ok ? e.arrayBuffer() : Promise.reject(Error(e.status + " : " + e.url))).then(a, c);
    }
  };
}
var ya = k.print || console.log.bind(console), za = k.printErr || console.error.bind(console);
Object.assign(k, ra);
ra = null;
k.thisProgram && (sa = k.thisProgram);
var Aa;
k.wasmBinary && (Aa = k.wasmBinary);
var Ba, Ca = !1, Da, J, Ea, Fa, K, O, Ga, Ia;
function Ja() {
  var b = Ba.buffer;
  k.HEAP8 = Da = new Int8Array(b);
  k.HEAP16 = Ea = new Int16Array(b);
  k.HEAPU8 = J = new Uint8Array(b);
  k.HEAPU16 = Fa = new Uint16Array(b);
  k.HEAP32 = K = new Int32Array(b);
  k.HEAPU32 = O = new Uint32Array(b);
  k.HEAPF32 = Ga = new Float32Array(b);
  k.HEAPF64 = Ia = new Float64Array(b);
}
var Ka = [], La = [], Ma = [];
function Na() {
  var b = k.preRun.shift();
  Ka.unshift(b);
}
var Oa = 0, Pa = null, Qa = null;
function Ra(b) {
  k.onAbort?.(b);
  b = "Aborted(" + b + ")";
  za(b);
  Ca = !0;
  b = new WebAssembly.RuntimeError(b + ". Build with -sASSERTIONS for more info.");
  ba(b);
  throw b;
}
var Sa = b => b.startsWith("data:application/octet-stream;base64,"), xa = b => b.startsWith("file://"), Ta;
function Ua(b) {
  if (b == Ta && Aa) {
    return new Uint8Array(Aa);
  }
  if (wa) {
    return wa(b);
  }
  throw "both async and sync fetching of the wasm failed";
}
function Va(b) {
  return Aa ? Promise.resolve().then(() => Ua(b)) : new Promise((a, c) => {
    ta(b, d => a(new Uint8Array(d)), () => {
      try {
        a(Ua(b));
      } catch (d) {
        c(d);
      }
    });
  });
}
function Wa(b, a, c) {
  return Va(b).then(d => WebAssembly.instantiate(d, a)).then(c, d => {
    za(`failed to asynchronously prepare wasm: ${d}`);
    Ra(d);
  });
}
function Xa(b, a) {
  var c = Ta;
  return Aa || "function" != typeof WebAssembly.instantiateStreaming || Sa(c) || xa(c) || "function" != typeof fetch ? Wa(c, b, a) : fetch(c, {credentials:"same-origin"}).then(d => WebAssembly.instantiateStreaming(d, b).then(a, function(e) {
    za(`wasm streaming compile failed: ${e}`);
    za("falling back to ArrayBuffer instantiation");
    return Wa(c, b, a);
  }));
}
var Ya = b => {
  for (; 0 < b.length;) {
    b.shift()(k);
  }
}, Za = (b, a) => Object.defineProperty(a, "name", {value:b}), $a = [], P = [], Q, T = b => {
  if (!b) {
    throw new Q("Cannot use deleted val. handle = " + b);
  }
  return P[b];
}, ab = b => {
  switch(b) {
    case void 0:
      return 2;
    case null:
      return 4;
    case !0:
      return 6;
    case !1:
      return 8;
    default:
      const a = $a.pop() || P.length;
      P[a] = b;
      P[a + 1] = 1;
      return a;
  }
}, bb = b => {
  var a = Error, c = Za(b, function(d) {
    this.name = b;
    this.message = d;
    d = Error(d).stack;
    void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
  });
  c.prototype = Object.create(a.prototype);
  c.prototype.constructor = c;
  c.prototype.toString = function() {
    return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
  };
  return c;
}, cb, db, U = b => {
  for (var a = ""; J[b];) {
    a += db[J[b++]];
  }
  return a;
}, eb = [], fb = () => {
  for (; eb.length;) {
    var b = eb.pop();
    b.g.M = !1;
    b["delete"]();
  }
}, gb, hb = {}, ib = (b, a) => {
  if (void 0 === a) {
    throw new Q("ptr should not be undefined");
  }
  for (; b.o;) {
    a = b.S(a), b = b.o;
  }
  return a;
}, jb = {}, mb = b => {
  b = kb(b);
  var a = U(b);
  lb(b);
  return a;
}, nb = (b, a) => {
  var c = jb[b];
  if (void 0 === c) {
    throw b = `${a} has unknown type ${mb(b)}`, new Q(b);
  }
  return c;
}, ob = () => {
}, pb = !1, qb = (b, a, c) => {
  if (a === c) {
    return b;
  }
  if (void 0 === c.o) {
    return null;
  }
  b = qb(b, a, c.o);
  return null === b ? null : c.La(b);
}, rb = {}, sb = (b, a) => {
  a = ib(b, a);
  return hb[a];
}, wb, yb = (b, a) => {
  if (!a.j || !a.i) {
    throw new wb("makeClassHandle requires ptr and ptrType");
  }
  if (!!a.A !== !!a.s) {
    throw new wb("Both smartPtrType and smartPtr must be specified");
  }
  a.count = {value:1};
  return xb(Object.create(b, {g:{value:a, writable:!0,},}));
}, xb = b => {
  if ("undefined" === typeof FinalizationRegistry) {
    return xb = a => a, b;
  }
  pb = new FinalizationRegistry(a => {
    a = a.g;
    --a.count.value;
    0 === a.count.value && (a.s ? a.A.D(a.s) : a.j.h.D(a.i));
  });
  xb = a => {
    var c = a.g;
    c.s && pb.register(a, {g:c}, a);
    return a;
  };
  ob = a => {
    pb.unregister(a);
  };
  return xb(b);
}, zb = {}, Ab = b => {
  for (; b.length;) {
    var a = b.pop();
    b.pop()(a);
  }
};
function Bb(b) {
  return this.fromWireType(O[b >> 2]);
}
var Cb = {}, Db = {}, X = (b, a, c) => {
  function d(h) {
    h = c(h);
    if (h.length !== b.length) {
      throw new wb("Mismatched type converter count");
    }
    for (var l = 0; l < b.length; ++l) {
      Eb(b[l], h[l]);
    }
  }
  b.forEach(function(h) {
    Db[h] = a;
  });
  var e = Array(a.length), f = [], m = 0;
  a.forEach((h, l) => {
    jb.hasOwnProperty(h) ? e[l] = jb[h] : (f.push(h), Cb.hasOwnProperty(h) || (Cb[h] = []), Cb[h].push(() => {
      e[l] = jb[h];
      ++m;
      m === f.length && d(e);
    }));
  });
  0 === f.length && d(e);
};
function Fb(b, a, c = {}) {
  var d = a.name;
  if (!b) {
    throw new Q(`type "${d}" must have a positive integer typeid pointer`);
  }
  if (jb.hasOwnProperty(b)) {
    if (c.Va) {
      return;
    }
    throw new Q(`Cannot register type '${d}' twice`);
  }
  jb[b] = a;
  delete Db[b];
  Cb.hasOwnProperty(b) && (a = Cb[b], delete Cb[b], a.forEach(e => e()));
}
function Eb(b, a, c = {}) {
  if (!("argPackAdvance" in a)) {
    throw new TypeError("registerType registeredInstance requires argPackAdvance");
  }
  return Fb(b, a, c);
}
var Gb = b => {
  throw new Q(b.g.j.h.name + " instance already deleted");
};
function Hb() {
}
var Ib = (b, a, c) => {
  if (void 0 === b[a].l) {
    var d = b[a];
    b[a] = function(...e) {
      if (!b[a].l.hasOwnProperty(e.length)) {
        throw new Q(`Function '${c}' called with an invalid number of arguments (${e.length}) - expects one of (${b[a].l})!`);
      }
      return b[a].l[e.length].apply(this, e);
    };
    b[a].l = [];
    b[a].l[d.L] = d;
  }
}, Jb = (b, a, c) => {
  if (k.hasOwnProperty(b)) {
    if (void 0 === c || void 0 !== k[b].l && void 0 !== k[b].l[c]) {
      throw new Q(`Cannot register public name '${b}' twice`);
    }
    Ib(k, b, b);
    if (k.hasOwnProperty(c)) {
      throw new Q(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`);
    }
    k[b].l[c] = a;
  } else {
    k[b] = a, void 0 !== c && (k[b].nb = c);
  }
}, Kb = b => {
  if (void 0 === b) {
    return "_unknown";
  }
  b = b.replace(/[^a-zA-Z0-9_]/g, "$");
  var a = b.charCodeAt(0);
  return 48 <= a && 57 >= a ? `_${b}` : b;
};
function Lb(b, a, c, d, e, f, m, h) {
  this.name = b;
  this.constructor = a;
  this.C = c;
  this.D = d;
  this.o = e;
  this.Qa = f;
  this.S = m;
  this.La = h;
  this.wa = [];
}
var Mb = (b, a, c) => {
  for (; a !== c;) {
    if (!a.S) {
      throw new Q(`Expected null or instance of ${c.name}, got an instance of ${a.name}`);
    }
    b = a.S(b);
    a = a.o;
  }
  return b;
};
function Nb(b, a) {
  if (null === a) {
    if (this.ea) {
      throw new Q(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!a.g) {
    throw new Q(`Cannot pass "${Ob(a)}" as a ${this.name}`);
  }
  if (!a.g.i) {
    throw new Q(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  return Mb(a.g.i, a.g.j.h, this.h);
}
function Pb(b, a) {
  if (null === a) {
    if (this.ea) {
      throw new Q(`null is not a valid ${this.name}`);
    }
    if (this.V) {
      var c = this.fa();
      null !== b && b.push(this.D, c);
      return c;
    }
    return 0;
  }
  if (!a || !a.g) {
    throw new Q(`Cannot pass "${Ob(a)}" as a ${this.name}`);
  }
  if (!a.g.i) {
    throw new Q(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (!this.U && a.g.j.U) {
    throw new Q(`Cannot convert argument of type ${a.g.A ? a.g.A.name : a.g.j.name} to parameter type ${this.name}`);
  }
  c = Mb(a.g.i, a.g.j.h, this.h);
  if (this.V) {
    if (void 0 === a.g.s) {
      throw new Q("Passing raw pointer to smart pointer is illegal");
    }
    switch(this.gb) {
      case 0:
        if (a.g.A === this) {
          c = a.g.s;
        } else {
          throw new Q(`Cannot convert argument of type ${a.g.A ? a.g.A.name : a.g.j.name} to parameter type ${this.name}`);
        }
        break;
      case 1:
        c = a.g.s;
        break;
      case 2:
        if (a.g.A === this) {
          c = a.g.s;
        } else {
          var d = a.clone();
          c = this.bb(c, ab(() => d["delete"]()));
          null !== b && b.push(this.D, c);
        }
        break;
      default:
        throw new Q("Unsupporting sharing policy");
    }
  }
  return c;
}
function Qb(b, a) {
  if (null === a) {
    if (this.ea) {
      throw new Q(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!a.g) {
    throw new Q(`Cannot pass "${Ob(a)}" as a ${this.name}`);
  }
  if (!a.g.i) {
    throw new Q(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (a.g.j.U) {
    throw new Q(`Cannot convert argument of type ${a.g.j.name} to parameter type ${this.name}`);
  }
  return Mb(a.g.i, a.g.j.h, this.h);
}
function Rb(b, a, c, d, e, f, m, h, l, n, r) {
  this.name = b;
  this.h = a;
  this.ea = c;
  this.U = d;
  this.V = e;
  this.ab = f;
  this.gb = m;
  this.xa = h;
  this.fa = l;
  this.bb = n;
  this.D = r;
  e || void 0 !== a.o ? this.toWireType = Pb : (this.toWireType = d ? Nb : Qb, this.B = null);
}
var Sb = (b, a, c) => {
  if (!k.hasOwnProperty(b)) {
    throw new wb("Replacing nonexistent public symbol");
  }
  void 0 !== k[b].l && void 0 !== c ? k[b].l[c] = a : (k[b] = a, k[b].L = c);
}, Tb = [], Ub, Vb = b => {
  var a = Tb[b];
  a || (b >= Tb.length && (Tb.length = b + 1), Tb[b] = a = Ub.get(b));
  return a;
}, Wb = (b, a, c = []) => {
  b.includes("j") ? (b = b.replace(/p/g, "i"), a = (0,k["dynCall_" + b])(a, ...c)) : a = Vb(a)(...c);
  return a;
}, Xb = (b, a) => (...c) => Wb(b, a, c), Y = (b, a) => {
  b = U(b);
  var c = b.includes("j") ? Xb(b, a) : Vb(a);
  if ("function" != typeof c) {
    throw new Q(`unknown function pointer with signature ${b}: ${a}`);
  }
  return c;
}, Yb, Zb = (b, a) => {
  function c(f) {
    e[f] || jb[f] || (Db[f] ? Db[f].forEach(c) : (d.push(f), e[f] = !0));
  }
  var d = [], e = {};
  a.forEach(c);
  throw new Yb(`${b}: ` + d.map(mb).join([", "]));
};
function $b(b) {
  for (var a = 1; a < b.length; ++a) {
    if (null !== b[a] && void 0 === b[a].B) {
      return !0;
    }
  }
  return !1;
}
function ac(b, a, c, d, e) {
  var f = a.length;
  if (2 > f) {
    throw new Q("argTypes array size mismatch! Must at least get return value and 'this' types!");
  }
  var m = null !== a[1] && null !== c, h = $b(a), l = "void" !== a[0].name, n = f - 2, r = Array(n), w = [], y = [];
  return Za(b, function(...g) {
    if (g.length !== n) {
      throw new Q(`function ${b} called with ${g.length} arguments, expected ${n}`);
    }
    y.length = 0;
    w.length = m ? 2 : 1;
    w[0] = e;
    if (m) {
      var t = a[1].toWireType(y, this);
      w[1] = t;
    }
    for (var q = 0; q < n; ++q) {
      r[q] = a[q + 2].toWireType(y, g[q]), w.push(r[q]);
    }
    g = d(...w);
    if (h) {
      Ab(y);
    } else {
      for (q = m ? 1 : 2; q < a.length; q++) {
        var F = 1 === q ? t : r[q - 2];
        null !== a[q].B && a[q].B(F);
      }
    }
    t = l ? a[0].fromWireType(g) : void 0;
    return t;
  });
}
var bc = (b, a) => {
  for (var c = [], d = 0; d < b; d++) {
    c.push(O[a + 4 * d >> 2]);
  }
  return c;
}, cc = b => {
  b = b.trim();
  const a = b.indexOf("(");
  return -1 !== a ? b.substr(0, a) : b;
}, dc = (b, a, c) => {
  if (!(b instanceof Object)) {
    throw new Q(`${c} with invalid "this": ${b}`);
  }
  if (!(b instanceof a.h.constructor)) {
    throw new Q(`${c} incompatible with "this" of type ${b.constructor.name}`);
  }
  if (!b.g.i) {
    throw new Q(`cannot call emscripten binding method ${c} on deleted object`);
  }
  return Mb(b.g.i, b.g.j.h, a.h);
}, ec = b => {
  9 < b && 0 === --P[b + 1] && (P[b] = void 0, $a.push(b));
}, fc = {name:"emscripten::val", fromWireType:b => {
  var a = T(b);
  ec(b);
  return a;
}, toWireType:(b, a) => ab(a), argPackAdvance:8, readValueFromPointer:Bb, B:null,}, gc = (b, a, c) => {
  switch(a) {
    case 1:
      return c ? function(d) {
        return this.fromWireType(Da[d]);
      } : function(d) {
        return this.fromWireType(J[d]);
      };
    case 2:
      return c ? function(d) {
        return this.fromWireType(Ea[d >> 1]);
      } : function(d) {
        return this.fromWireType(Fa[d >> 1]);
      };
    case 4:
      return c ? function(d) {
        return this.fromWireType(K[d >> 2]);
      } : function(d) {
        return this.fromWireType(O[d >> 2]);
      };
    default:
      throw new TypeError(`invalid integer width (${a}): ${b}`);
  }
}, Ob = b => {
  if (null === b) {
    return "null";
  }
  var a = typeof b;
  return "object" === a || "array" === a || "function" === a ? b.toString() : "" + b;
}, hc = (b, a) => {
  switch(a) {
    case 4:
      return function(c) {
        return this.fromWireType(Ga[c >> 2]);
      };
    case 8:
      return function(c) {
        return this.fromWireType(Ia[c >> 3]);
      };
    default:
      throw new TypeError(`invalid float width (${a}): ${b}`);
  }
}, ic = (b, a, c) => {
  switch(a) {
    case 1:
      return c ? d => Da[d] : d => J[d];
    case 2:
      return c ? d => Ea[d >> 1] : d => Fa[d >> 1];
    case 4:
      return c ? d => K[d >> 2] : d => O[d >> 2];
    default:
      throw new TypeError(`invalid integer width (${a}): ${b}`);
  }
}, jc = (b, a, c, d) => {
  if (0 < d) {
    d = c + d - 1;
    for (var e = 0; e < b.length; ++e) {
      var f = b.charCodeAt(e);
      if (55296 <= f && 57343 >= f) {
        var m = b.charCodeAt(++e);
        f = 65536 + ((f & 1023) << 10) | m & 1023;
      }
      if (127 >= f) {
        if (c >= d) {
          break;
        }
        a[c++] = f;
      } else {
        if (2047 >= f) {
          if (c + 1 >= d) {
            break;
          }
          a[c++] = 192 | f >> 6;
        } else {
          if (65535 >= f) {
            if (c + 2 >= d) {
              break;
            }
            a[c++] = 224 | f >> 12;
          } else {
            if (c + 3 >= d) {
              break;
            }
            a[c++] = 240 | f >> 18;
            a[c++] = 128 | f >> 12 & 63;
          }
          a[c++] = 128 | f >> 6 & 63;
        }
        a[c++] = 128 | f & 63;
      }
    }
    a[c] = 0;
  }
}, kc = b => {
  for (var a = 0, c = 0; c < b.length; ++c) {
    var d = b.charCodeAt(c);
    127 >= d ? a++ : 2047 >= d ? a += 2 : 55296 <= d && 57343 >= d ? (a += 4, ++c) : a += 3;
  }
  return a;
}, oc = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, pc = (b, a, c) => {
  var d = a + c;
  for (c = a; b[c] && !(c >= d);) {
    ++c;
  }
  if (16 < c - a && b.buffer && oc) {
    return oc.decode(b.subarray(a, c));
  }
  for (d = ""; a < c;) {
    var e = b[a++];
    if (e & 128) {
      var f = b[a++] & 63;
      if (192 == (e & 224)) {
        d += String.fromCharCode((e & 31) << 6 | f);
      } else {
        var m = b[a++] & 63;
        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | m : (e & 7) << 18 | f << 12 | m << 6 | b[a++] & 63;
        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
      }
    } else {
      d += String.fromCharCode(e);
    }
  }
  return d;
}, qc = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, rc = (b, a) => {
  var c = b >> 1;
  for (var d = c + a / 2; !(c >= d) && Fa[c];) {
    ++c;
  }
  c <<= 1;
  if (32 < c - b && qc) {
    return qc.decode(J.subarray(b, c));
  }
  c = "";
  for (d = 0; !(d >= a / 2); ++d) {
    var e = Ea[b + 2 * d >> 1];
    if (0 == e) {
      break;
    }
    c += String.fromCharCode(e);
  }
  return c;
}, sc = (b, a, c) => {
  c ??= 2147483647;
  if (2 > c) {
    return 0;
  }
  c -= 2;
  var d = a;
  c = c < 2 * b.length ? c / 2 : b.length;
  for (var e = 0; e < c; ++e) {
    Ea[a >> 1] = b.charCodeAt(e), a += 2;
  }
  Ea[a >> 1] = 0;
  return a - d;
}, tc = b => 2 * b.length, uc = (b, a) => {
  for (var c = 0, d = ""; !(c >= a / 4);) {
    var e = K[b + 4 * c >> 2];
    if (0 == e) {
      break;
    }
    ++c;
    65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
  }
  return d;
}, vc = (b, a, c) => {
  c ??= 2147483647;
  if (4 > c) {
    return 0;
  }
  var d = a;
  c = d + c - 4;
  for (var e = 0; e < b.length; ++e) {
    var f = b.charCodeAt(e);
    if (55296 <= f && 57343 >= f) {
      var m = b.charCodeAt(++e);
      f = 65536 + ((f & 1023) << 10) | m & 1023;
    }
    K[a >> 2] = f;
    a += 4;
    if (a + 4 > c) {
      break;
    }
  }
  K[a >> 2] = 0;
  return a - d;
}, wc = b => {
  for (var a = 0, c = 0; c < b.length; ++c) {
    var d = b.charCodeAt(c);
    55296 <= d && 57343 >= d && ++c;
    a += 4;
  }
  return a;
}, xc = (b, a, c) => {
  var d = [];
  b = b.toWireType(d, c);
  d.length && (O[a >> 2] = ab(d));
  return b;
}, yc = {}, zc = b => {
  var a = yc[b];
  return void 0 === a ? U(b) : a;
}, Ac = [], Bc = b => {
  var a = Ac.length;
  Ac.push(b);
  return a;
}, Cc = (b, a) => {
  for (var c = Array(b), d = 0; d < b; ++d) {
    c[d] = nb(O[a + 4 * d >> 2], "parameter " + d);
  }
  return c;
}, Dc = Reflect.construct, Ec = {}, Gc = () => {
  if (!Fc) {
    var b = {USER:"web_user", LOGNAME:"web_user", PATH:"/", PWD:"/", HOME:"/home/web_user", LANG:("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _:sa || "./this.program"}, a;
    for (a in Ec) {
      void 0 === Ec[a] ? delete b[a] : b[a] = Ec[a];
    }
    var c = [];
    for (a in b) {
      c.push(`${a}=${b[a]}`);
    }
    Fc = c;
  }
  return Fc;
}, Fc, Hc = [null, [], []], Ic = b => 0 === b % 4 && (0 !== b % 100 || 0 === b % 400), Jc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Kc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Lc(b) {
  var a = Array(kc(b) + 1);
  jc(b, a, 0, a.length);
  return a;
}
var Mc = (b, a, c, d) => {
  function e(g, t, q) {
    for (g = "number" == typeof g ? g.toString() : g || ""; g.length < t;) {
      g = q[0] + g;
    }
    return g;
  }
  function f(g, t) {
    return e(g, t, "0");
  }
  function m(g, t) {
    function q(E) {
      return 0 > E ? -1 : 0 < E ? 1 : 0;
    }
    var F;
    0 === (F = q(g.getFullYear() - t.getFullYear())) && 0 === (F = q(g.getMonth() - t.getMonth())) && (F = q(g.getDate() - t.getDate()));
    return F;
  }
  function h(g) {
    switch(g.getDay()) {
      case 0:
        return new Date(g.getFullYear() - 1, 11, 29);
      case 1:
        return g;
      case 2:
        return new Date(g.getFullYear(), 0, 3);
      case 3:
        return new Date(g.getFullYear(), 0, 2);
      case 4:
        return new Date(g.getFullYear(), 0, 1);
      case 5:
        return new Date(g.getFullYear() - 1, 11, 31);
      case 6:
        return new Date(g.getFullYear() - 1, 11, 30);
    }
  }
  function l(g) {
    var t = g.J;
    for (g = new Date((new Date(g.K + 1900, 0, 1)).getTime()); 0 < t;) {
      var q = g.getMonth(), F = (Ic(g.getFullYear()) ? Jc : Kc)[q];
      if (t > F - g.getDate()) {
        t -= F - g.getDate() + 1, g.setDate(1), 11 > q ? g.setMonth(q + 1) : (g.setMonth(0), g.setFullYear(g.getFullYear() + 1));
      } else {
        g.setDate(g.getDate() + t);
        break;
      }
    }
    q = new Date(g.getFullYear() + 1, 0, 4);
    t = h(new Date(g.getFullYear(), 0, 4));
    q = h(q);
    return 0 >= m(t, g) ? 0 >= m(q, g) ? g.getFullYear() + 1 : g.getFullYear() : g.getFullYear() - 1;
  }
  var n = O[d + 40 >> 2];
  d = {jb:K[d >> 2], ib:K[d + 4 >> 2], Z:K[d + 8 >> 2], ha:K[d + 12 >> 2], $:K[d + 16 >> 2], K:K[d + 20 >> 2], F:K[d + 24 >> 2], J:K[d + 28 >> 2], ob:K[d + 32 >> 2], hb:K[d + 36 >> 2], kb:n ? n ? pc(J, n) : "" : ""};
  c = c ? pc(J, c) : "";
  n = {"%c":"%a %b %d %H:%M:%S %Y", "%D":"%m/%d/%y", "%F":"%Y-%m-%d", "%h":"%b", "%r":"%I:%M:%S %p", "%R":"%H:%M", "%T":"%H:%M:%S", "%x":"%m/%d/%y", "%X":"%H:%M:%S", "%Ec":"%c", "%EC":"%C", "%Ex":"%m/%d/%y", "%EX":"%H:%M:%S", "%Ey":"%y", "%EY":"%Y", "%Od":"%d", "%Oe":"%e", "%OH":"%H", "%OI":"%I", "%Om":"%m", "%OM":"%M", "%OS":"%S", "%Ou":"%u", "%OU":"%U", "%OV":"%V", "%Ow":"%w", "%OW":"%W", "%Oy":"%y",};
  for (var r in n) {
    c = c.replace(new RegExp(r, "g"), n[r]);
  }
  var w = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), y = "January February March April May June July August September October November December".split(" ");
  n = {"%a":g => w[g.F].substring(0, 3), "%A":g => w[g.F], "%b":g => y[g.$].substring(0, 3), "%B":g => y[g.$], "%C":g => f((g.K + 1900) / 100 | 0, 2), "%d":g => f(g.ha, 2), "%e":g => e(g.ha, 2, " "), "%g":g => l(g).toString().substring(2), "%G":l, "%H":g => f(g.Z, 2), "%I":g => {
    g = g.Z;
    0 == g ? g = 12 : 12 < g && (g -= 12);
    return f(g, 2);
  }, "%j":g => {
    for (var t = 0, q = 0; q <= g.$ - 1; t += (Ic(g.K + 1900) ? Jc : Kc)[q++]) {
    }
    return f(g.ha + t, 3);
  }, "%m":g => f(g.$ + 1, 2), "%M":g => f(g.ib, 2), "%n":() => "\n", "%p":g => 0 <= g.Z && 12 > g.Z ? "AM" : "PM", "%S":g => f(g.jb, 2), "%t":() => "\t", "%u":g => g.F || 7, "%U":g => f(Math.floor((g.J + 7 - g.F) / 7), 2), "%V":g => {
    var t = Math.floor((g.J + 7 - (g.F + 6) % 7) / 7);
    2 >= (g.F + 371 - g.J - 2) % 7 && t++;
    if (t) {
      53 == t && (q = (g.F + 371 - g.J) % 7, 4 == q || 3 == q && Ic(g.K) || (t = 1));
    } else {
      t = 52;
      var q = (g.F + 7 - g.J - 1) % 7;
      (4 == q || 5 == q && Ic(g.K % 400 - 1)) && t++;
    }
    return f(t, 2);
  }, "%w":g => g.F, "%W":g => f(Math.floor((g.J + 7 - (g.F + 6) % 7) / 7), 2), "%y":g => (g.K + 1900).toString().substring(2), "%Y":g => g.K + 1900, "%z":g => {
    g = g.hb;
    var t = 0 <= g;
    g = Math.abs(g) / 60;
    return (t ? "+" : "-") + String("0000" + (g / 60 * 100 + g % 60)).slice(-4);
  }, "%Z":g => g.kb, "%%":() => "%"};
  c = c.replace(/%%/g, "\x00\x00");
  for (r in n) {
    c.includes(r) && (c = c.replace(new RegExp(r, "g"), n[r](d)));
  }
  c = c.replace(/\0\0/g, "%");
  r = Lc(c);
  if (r.length > a) {
    return 0;
  }
  Da.set(r, b);
  return r.length - 1;
};
Q = k.BindingError = class extends Error {
  constructor(b) {
    super(b);
    this.name = "BindingError";
  }
};
P.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1,);
k.count_emval_handles = () => P.length / 2 - 5 - $a.length;
cb = k.PureVirtualError = bb("PureVirtualError");
for (var Nc = Array(256), Oc = 0; 256 > Oc; ++Oc) {
  Nc[Oc] = String.fromCharCode(Oc);
}
db = Nc;
k.getInheritedInstanceCount = () => Object.keys(hb).length;
k.getLiveInheritedInstances = () => {
  var b = [], a;
  for (a in hb) {
    hb.hasOwnProperty(a) && b.push(hb[a]);
  }
  return b;
};
k.flushPendingDeletes = fb;
k.setDelayFunction = b => {
  gb = b;
  eb.length && gb && gb(fb);
};
wb = k.InternalError = class extends Error {
  constructor(b) {
    super(b);
    this.name = "InternalError";
  }
};
Object.assign(Hb.prototype, {isAliasOf:function(b) {
  if (!(this instanceof Hb && b instanceof Hb)) {
    return !1;
  }
  var a = this.g.j.h, c = this.g.i;
  b.g = b.g;
  var d = b.g.j.h;
  for (b = b.g.i; a.o;) {
    c = a.S(c), a = a.o;
  }
  for (; d.o;) {
    b = d.S(b), d = d.o;
  }
  return a === d && c === b;
}, clone:function() {
  this.g.i || Gb(this);
  if (this.g.O) {
    return this.g.count.value += 1, this;
  }
  var b = xb, a = Object, c = a.create, d = Object.getPrototypeOf(this), e = this.g;
  b = b(c.call(a, d, {g:{value:{count:e.count, M:e.M, O:e.O, i:e.i, j:e.j, s:e.s, A:e.A,},}}));
  b.g.count.value += 1;
  b.g.M = !1;
  return b;
}, ["delete"]() {
  this.g.i || Gb(this);
  if (this.g.M && !this.g.O) {
    throw new Q("Object already scheduled for deletion");
  }
  ob(this);
  var b = this.g;
  --b.count.value;
  0 === b.count.value && (b.s ? b.A.D(b.s) : b.j.h.D(b.i));
  this.g.O || (this.g.s = void 0, this.g.i = void 0);
}, isDeleted:function() {
  return !this.g.i;
}, deleteLater:function() {
  this.g.i || Gb(this);
  if (this.g.M && !this.g.O) {
    throw new Q("Object already scheduled for deletion");
  }
  eb.push(this);
  1 === eb.length && gb && gb(fb);
  this.g.M = !0;
  return this;
},});
Object.assign(Rb.prototype, {Ra(b) {
  this.xa && (b = this.xa(b));
  return b;
}, pa(b) {
  this.D?.(b);
}, argPackAdvance:8, readValueFromPointer:Bb, fromWireType:function(b) {
  function a() {
    return this.V ? yb(this.h.C, {j:this.ab, i:c, A:this, s:b,}) : yb(this.h.C, {j:this, i:b,});
  }
  var c = this.Ra(b);
  if (!c) {
    return this.pa(b), null;
  }
  var d = sb(this.h, c);
  if (void 0 !== d) {
    if (0 === d.g.count.value) {
      return d.g.i = c, d.g.s = b, d.clone();
    }
    d = d.clone();
    this.pa(b);
    return d;
  }
  d = this.h.Qa(c);
  d = rb[d];
  if (!d) {
    return a.call(this);
  }
  d = this.U ? d.Ha : d.pointerType;
  var e = qb(c, this.h, d.h);
  return null === e ? a.call(this) : this.V ? yb(d.h.C, {j:d, i:e, A:this, s:b,}) : yb(d.h.C, {j:d, i:e,});
},});
Yb = k.UnboundTypeError = bb("UnboundTypeError");
var Qc = {_abort_js:() => {
  Ra("");
}, _embind_create_inheriting_constructor:(b, a, c) => {
  b = U(b);
  a = nb(a, "wrapper");
  c = T(c);
  var d = a.h, e = d.C, f = d.o.C, m = d.o.constructor;
  b = Za(b, function(...h) {
    d.o.wa.forEach(function(l) {
      if (this[l] === f[l]) {
        throw new cb(`Pure virtual function ${l} must be implemented in JavaScript`);
      }
    }.bind(this));
    Object.defineProperty(this, "__parent", {value:e});
    this.__construct(...h);
  });
  e.__construct = function(...h) {
    if (this === e) {
      throw new Q("Pass correct 'this' to __construct");
    }
    h = m.implement(this, ...h);
    ob(h);
    var l = h.g;
    h.notifyOnDestruction();
    l.O = !0;
    Object.defineProperties(this, {g:{value:l}});
    xb(this);
    h = l.i;
    h = ib(d, h);
    if (hb.hasOwnProperty(h)) {
      throw new Q(`Tried to register registered instance: ${h}`);
    }
    hb[h] = this;
  };
  e.__destruct = function() {
    if (this === e) {
      throw new Q("Pass correct 'this' to __destruct");
    }
    ob(this);
    var h = this.g.i;
    h = ib(d, h);
    if (hb.hasOwnProperty(h)) {
      delete hb[h];
    } else {
      throw new Q(`Tried to unregister unregistered instance: ${h}`);
    }
  };
  b.prototype = Object.create(e);
  Object.assign(b.prototype, c);
  return ab(b);
}, _embind_finalize_value_object:b => {
  var a = zb[b];
  delete zb[b];
  var c = a.fa, d = a.D, e = a.sa, f = e.map(m => m.Ua).concat(e.map(m => m.eb));
  X([b], f, m => {
    var h = {};
    e.forEach((l, n) => {
      var r = m[n], w = l.Sa, y = l.Ta, g = m[n + e.length], t = l.cb, q = l.fb;
      h[l.Oa] = {read:F => r.fromWireType(w(y, F)), write:(F, E) => {
        var v = [];
        t(q, F, g.toWireType(v, E));
        Ab(v);
      }};
    });
    return [{name:a.name, fromWireType:l => {
      var n = {}, r;
      for (r in h) {
        n[r] = h[r].read(l);
      }
      d(l);
      return n;
    }, toWireType:(l, n) => {
      for (var r in h) {
        if (!(r in n)) {
          throw new TypeError(`Missing field: "${r}"`);
        }
      }
      var w = c();
      for (r in h) {
        h[r].write(w, n[r]);
      }
      null !== l && l.push(d, w);
      return w;
    }, argPackAdvance:8, readValueFromPointer:Bb, B:d,}];
  });
}, _embind_register_bigint:() => {
}, _embind_register_bool:(b, a, c, d) => {
  a = U(a);
  Eb(b, {name:a, fromWireType:function(e) {
    return !!e;
  }, toWireType:function(e, f) {
    return f ? c : d;
  }, argPackAdvance:8, readValueFromPointer:function(e) {
    return this.fromWireType(J[e]);
  }, B:null,});
}, _embind_register_class:(b, a, c, d, e, f, m, h, l, n, r, w, y) => {
  r = U(r);
  f = Y(e, f);
  h &&= Y(m, h);
  n &&= Y(l, n);
  y = Y(w, y);
  var g = Kb(r);
  Jb(g, function() {
    Zb(`Cannot construct ${r} due to unbound types`, [d]);
  });
  X([b, a, c], d ? [d] : [], t => {
    t = t[0];
    if (d) {
      var q = t.h;
      var F = q.C;
    } else {
      F = Hb.prototype;
    }
    t = Za(r, function(...N) {
      if (Object.getPrototypeOf(this) !== E) {
        throw new Q("Use 'new' to construct " + r);
      }
      if (void 0 === v.I) {
        throw new Q(r + " has no accessible constructor");
      }
      var R = v.I[N.length];
      if (void 0 === R) {
        throw new Q(`Tried to invoke ctor of ${r} with invalid number of parameters (${N.length}) - expected (${Object.keys(v.I).toString()}) parameters instead!`);
      }
      return R.apply(this, N);
    });
    var E = Object.create(F, {constructor:{value:t},});
    t.prototype = E;
    var v = new Lb(r, t, E, y, q, f, h, n);
    if (v.o) {
      var I;
      (I = v.o).T ?? (I.T = []);
      v.o.T.push(v);
    }
    q = new Rb(r, v, !0, !1, !1);
    I = new Rb(r + "*", v, !1, !1, !1);
    F = new Rb(r + " const*", v, !1, !0, !1);
    rb[b] = {pointerType:I, Ha:F};
    Sb(g, t);
    return [q, I, F];
  });
}, _embind_register_class_class_function:(b, a, c, d, e, f, m) => {
  var h = bc(c, d);
  a = U(a);
  a = cc(a);
  f = Y(e, f);
  X([], [b], l => {
    function n() {
      Zb(`Cannot call ${r} due to unbound types`, h);
    }
    l = l[0];
    var r = `${l.name}.${a}`;
    a.startsWith("@@") && (a = Symbol[a.substring(2)]);
    var w = l.h.constructor;
    void 0 === w[a] ? (n.L = c - 1, w[a] = n) : (Ib(w, a, r), w[a].l[c - 1] = n);
    X([], h, y => {
      y = ac(r, [y[0], null].concat(y.slice(1)), null, f, m);
      void 0 === w[a].l ? (y.L = c - 1, w[a] = y) : w[a].l[c - 1] = y;
      if (l.h.T) {
        for (const g of l.h.T) {
          g.constructor.hasOwnProperty(a) || (g.constructor[a] = y);
        }
      }
      return [];
    });
    return [];
  });
}, _embind_register_class_class_property:(b, a, c, d, e, f, m, h) => {
  a = U(a);
  f = Y(e, f);
  X([], [b], l => {
    l = l[0];
    var n = `${l.name}.${a}`, r = {get() {
      Zb(`Cannot access ${n} due to unbound types`, [c]);
    }, enumerable:!0, configurable:!0};
    r.set = h ? () => {
      Zb(`Cannot access ${n} due to unbound types`, [c]);
    } : () => {
      throw new Q(`${n} is a read-only property`);
    };
    Object.defineProperty(l.h.constructor, a, r);
    X([], [c], w => {
      w = w[0];
      var y = {get() {
        return w.fromWireType(f(d));
      }, enumerable:!0};
      h && (h = Y(m, h), y.set = g => {
        var t = [];
        h(d, w.toWireType(t, g));
        Ab(t);
      });
      Object.defineProperty(l.h.constructor, a, y);
      return [];
    });
    return [];
  });
}, _embind_register_class_constructor:(b, a, c, d, e, f) => {
  var m = bc(a, c);
  e = Y(d, e);
  X([], [b], h => {
    h = h[0];
    var l = `constructor ${h.name}`;
    void 0 === h.h.I && (h.h.I = []);
    if (void 0 !== h.h.I[a - 1]) {
      throw new Q(`Cannot register multiple constructors with identical number of parameters (${a - 1}) for class '${h.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
    }
    h.h.I[a - 1] = () => {
      Zb(`Cannot construct ${h.name} due to unbound types`, m);
    };
    X([], m, n => {
      n.splice(1, 0, null);
      h.h.I[a - 1] = ac(l, n, null, e, f);
      return [];
    });
    return [];
  });
}, _embind_register_class_function:(b, a, c, d, e, f, m, h) => {
  var l = bc(c, d);
  a = U(a);
  a = cc(a);
  f = Y(e, f);
  X([], [b], n => {
    function r() {
      Zb(`Cannot call ${w} due to unbound types`, l);
    }
    n = n[0];
    var w = `${n.name}.${a}`;
    a.startsWith("@@") && (a = Symbol[a.substring(2)]);
    h && n.h.wa.push(a);
    var y = n.h.C, g = y[a];
    void 0 === g || void 0 === g.l && g.className !== n.name && g.L === c - 2 ? (r.L = c - 2, r.className = n.name, y[a] = r) : (Ib(y, a, w), y[a].l[c - 2] = r);
    X([], l, t => {
      t = ac(w, t, n, f, m);
      void 0 === y[a].l ? (t.L = c - 2, y[a] = t) : y[a].l[c - 2] = t;
      return [];
    });
    return [];
  });
}, _embind_register_class_property:(b, a, c, d, e, f, m, h, l, n) => {
  a = U(a);
  e = Y(d, e);
  X([], [b], r => {
    r = r[0];
    var w = `${r.name}.${a}`, y = {get() {
      Zb(`Cannot access ${w} due to unbound types`, [c, m]);
    }, enumerable:!0, configurable:!0};
    y.set = l ? () => Zb(`Cannot access ${w} due to unbound types`, [c, m]) : () => {
      throw new Q(w + " is a read-only property");
    };
    Object.defineProperty(r.h.C, a, y);
    X([], l ? [c, m] : [c], g => {
      var t = g[0], q = {get() {
        var E = dc(this, r, w + " getter");
        return t.fromWireType(e(f, E));
      }, enumerable:!0};
      if (l) {
        l = Y(h, l);
        var F = g[1];
        q.set = function(E) {
          var v = dc(this, r, w + " setter"), I = [];
          l(n, v, F.toWireType(I, E));
          Ab(I);
        };
      }
      Object.defineProperty(r.h.C, a, q);
      return [];
    });
    return [];
  });
}, _embind_register_emval:b => Eb(b, fc), _embind_register_enum:(b, a, c, d) => {
  function e() {
  }
  a = U(a);
  e.values = {};
  Eb(b, {name:a, constructor:e, fromWireType:function(f) {
    return this.constructor.values[f];
  }, toWireType:(f, m) => m.value, argPackAdvance:8, readValueFromPointer:gc(a, c, d), B:null,});
  Jb(a, e);
}, _embind_register_enum_value:(b, a, c) => {
  var d = nb(b, "enum");
  a = U(a);
  b = d.constructor;
  d = Object.create(d.constructor.prototype, {value:{value:c}, constructor:{value:Za(`${d.name}_${a}`, function() {
  })},});
  b.values[c] = d;
  b[a] = d;
}, _embind_register_float:(b, a, c) => {
  a = U(a);
  Eb(b, {name:a, fromWireType:d => d, toWireType:(d, e) => e, argPackAdvance:8, readValueFromPointer:hc(a, c), B:null,});
}, _embind_register_function:(b, a, c, d, e, f) => {
  var m = bc(a, c);
  b = U(b);
  b = cc(b);
  e = Y(d, e);
  Jb(b, function() {
    Zb(`Cannot call ${b} due to unbound types`, m);
  }, a - 1);
  X([], m, h => {
    Sb(b, ac(b, [h[0], null].concat(h.slice(1)), null, e, f), a - 1);
    return [];
  });
}, _embind_register_integer:(b, a, c, d, e) => {
  a = U(a);
  -1 === e && (e = 4294967295);
  e = h => h;
  if (0 === d) {
    var f = 32 - 8 * c;
    e = h => h << f >>> f;
  }
  var m = a.includes("unsigned") ? function(h, l) {
    return l >>> 0;
  } : function(h, l) {
    return l;
  };
  Eb(b, {name:a, fromWireType:e, toWireType:m, argPackAdvance:8, readValueFromPointer:ic(a, c, 0 !== d), B:null,});
}, _embind_register_memory_view:(b, a, c) => {
  function d(f) {
    return new e(Da.buffer, O[f + 4 >> 2], O[f >> 2]);
  }
  var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,][a];
  c = U(c);
  Eb(b, {name:c, fromWireType:d, argPackAdvance:8, readValueFromPointer:d,}, {Va:!0,});
}, _embind_register_std_string:(b, a) => {
  a = U(a);
  var c = "std::string" === a;
  Eb(b, {name:a, fromWireType:function(d) {
    var e = O[d >> 2], f = d + 4;
    if (c) {
      for (var m = f, h = 0; h <= e; ++h) {
        var l = f + h;
        if (h == e || 0 == J[l]) {
          m = m ? pc(J, m, l - m) : "";
          if (void 0 === n) {
            var n = m;
          } else {
            n += String.fromCharCode(0), n += m;
          }
          m = l + 1;
        }
      }
    } else {
      n = Array(e);
      for (h = 0; h < e; ++h) {
        n[h] = String.fromCharCode(J[f + h]);
      }
      n = n.join("");
    }
    lb(d);
    return n;
  }, toWireType:function(d, e) {
    e instanceof ArrayBuffer && (e = new Uint8Array(e));
    var f = "string" == typeof e;
    if (!(f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array)) {
      throw new Q("Cannot pass non-string to std::string");
    }
    var m = c && f ? kc(e) : e.length;
    var h = Pc(4 + m + 1), l = h + 4;
    O[h >> 2] = m;
    if (c && f) {
      jc(e, J, l, m + 1);
    } else {
      if (f) {
        for (f = 0; f < m; ++f) {
          var n = e.charCodeAt(f);
          if (255 < n) {
            throw lb(l), new Q("String has UTF-16 code units that do not fit in 8 bits");
          }
          J[l + f] = n;
        }
      } else {
        for (f = 0; f < m; ++f) {
          J[l + f] = e[f];
        }
      }
    }
    null !== d && d.push(lb, h);
    return h;
  }, argPackAdvance:8, readValueFromPointer:Bb, B(d) {
    lb(d);
  },});
}, _embind_register_std_wstring:(b, a, c) => {
  c = U(c);
  if (2 === a) {
    var d = rc;
    var e = sc;
    var f = tc;
    var m = h => Fa[h >> 1];
  } else {
    4 === a && (d = uc, e = vc, f = wc, m = h => O[h >> 2]);
  }
  Eb(b, {name:c, fromWireType:h => {
    for (var l = O[h >> 2], n, r = h + 4, w = 0; w <= l; ++w) {
      var y = h + 4 + w * a;
      if (w == l || 0 == m(y)) {
        r = d(r, y - r), void 0 === n ? n = r : (n += String.fromCharCode(0), n += r), r = y + a;
      }
    }
    lb(h);
    return n;
  }, toWireType:(h, l) => {
    if ("string" != typeof l) {
      throw new Q(`Cannot pass non-string to C++ string type ${c}`);
    }
    var n = f(l), r = Pc(4 + n + a);
    O[r >> 2] = n / a;
    e(l, r + 4, n + a);
    null !== h && h.push(lb, r);
    return r;
  }, argPackAdvance:8, readValueFromPointer:Bb, B(h) {
    lb(h);
  }});
}, _embind_register_value_object:(b, a, c, d, e, f) => {
  zb[b] = {name:U(a), fa:Y(c, d), D:Y(e, f), sa:[],};
}, _embind_register_value_object_field:(b, a, c, d, e, f, m, h, l, n) => {
  zb[b].sa.push({Oa:U(a), Ua:c, Sa:Y(d, e), Ta:f, eb:m, cb:Y(h, l), fb:n,});
}, _embind_register_void:(b, a) => {
  a = U(a);
  Eb(b, {mb:!0, name:a, argPackAdvance:0, fromWireType:() => {
  }, toWireType:() => {
  },});
}, _emscripten_get_now_is_monotonic:() => 1, _emscripten_memcpy_js:(b, a, c) => J.copyWithin(b, a, a + c), _emval_as:(b, a, c) => {
  b = T(b);
  a = nb(a, "emval::as");
  return xc(a, c, b);
}, _emval_call_method:(b, a, c, d, e) => {
  b = Ac[b];
  a = T(a);
  c = zc(c);
  return b(a, a[c], d, e);
}, _emval_decref:ec, _emval_get_method_caller:(b, a, c) => {
  var d = Cc(b, a), e = d.shift();
  b--;
  var f = Array(b);
  a = `methodCaller<(${d.map(m => m.name).join(", ")}) => ${e.name}>`;
  return Bc(Za(a, (m, h, l, n) => {
    for (var r = 0, w = 0; w < b; ++w) {
      f[w] = d[w].readValueFromPointer(n + r), r += d[w].argPackAdvance;
    }
    m = 1 === c ? Dc(h, f) : h.apply(m, f);
    return xc(e, l, m);
  }));
}, _emval_get_module_property:b => {
  b = zc(b);
  return ab(k[b]);
}, _emval_get_property:(b, a) => {
  b = T(b);
  a = T(a);
  return ab(b[a]);
}, _emval_incref:b => {
  9 < b && (P[b + 1] += 1);
}, _emval_new_array:() => ab([]), _emval_new_cstring:b => ab(zc(b)), _emval_new_object:() => ab({}), _emval_run_destructors:b => {
  var a = T(b);
  Ab(a);
  ec(b);
}, _emval_set_property:(b, a, c) => {
  b = T(b);
  a = T(a);
  c = T(c);
  b[a] = c;
}, _emval_take_value:(b, a) => {
  b = nb(b, "_emval_take_value");
  b = b.readValueFromPointer(a);
  return ab(b);
}, emscripten_date_now:() => Date.now(), emscripten_get_now:() => performance.now(), emscripten_resize_heap:b => {
  var a = J.length;
  b >>>= 0;
  if (2147483648 < b) {
    return !1;
  }
  for (var c = 1; 4 >= c; c *= 2) {
    var d = a * (1 + 0.2 / c);
    d = Math.min(d, b + 100663296);
    var e = Math;
    d = Math.max(b, d);
    a: {
      e = (e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - Ba.buffer.byteLength + 65535) / 65536;
      try {
        Ba.grow(e);
        Ja();
        var f = 1;
        break a;
      } catch (m) {
      }
      f = void 0;
    }
    if (f) {
      return !0;
    }
  }
  return !1;
}, environ_get:(b, a) => {
  var c = 0;
  Gc().forEach((d, e) => {
    var f = a + c;
    e = O[b + 4 * e >> 2] = f;
    for (f = 0; f < d.length; ++f) {
      Da[e++] = d.charCodeAt(f);
    }
    Da[e] = 0;
    c += d.length + 1;
  });
  return 0;
}, environ_sizes_get:(b, a) => {
  var c = Gc();
  O[b >> 2] = c.length;
  var d = 0;
  c.forEach(e => d += e.length + 1);
  O[a >> 2] = d;
  return 0;
}, fd_close:() => 52, fd_seek:function() {
  return 70;
}, fd_write:(b, a, c, d) => {
  for (var e = 0, f = 0; f < c; f++) {
    var m = O[a >> 2], h = O[a + 4 >> 2];
    a += 8;
    for (var l = 0; l < h; l++) {
      var n = J[m + l], r = Hc[b];
      0 === n || 10 === n ? ((1 === b ? ya : za)(pc(r, 0)), r.length = 0) : r.push(n);
    }
    e += h;
  }
  O[d >> 2] = e;
  return 0;
}, strftime_l:(b, a, c, d) => Mc(b, a, c, d)}, Z = function() {
  function b(c) {
    Z = c.exports;
    Ba = Z.memory;
    Ja();
    Ub = Z.__indirect_function_table;
    La.unshift(Z.__wasm_call_ctors);
    Oa--;
    k.monitorRunDependencies?.(Oa);
    0 == Oa && (null !== Pa && (clearInterval(Pa), Pa = null), Qa && (c = Qa, Qa = null, c()));
    return Z;
  }
  var a = {env:Qc, wasi_snapshot_preview1:Qc,};
  Oa++;
  k.monitorRunDependencies?.(Oa);
  if (k.instantiateWasm) {
    try {
      return k.instantiateWasm(a, b);
    } catch (c) {
      za(`Module.instantiateWasm callback failed with error: ${c}`), ba(c);
    }
  }
  Ta ||= Sa("canvas_advanced.wasm") ? "canvas_advanced.wasm" : k.locateFile ? k.locateFile("canvas_advanced.wasm", x) : x + "canvas_advanced.wasm";
  Xa(a, function(c) {
    b(c.instance);
  }).catch(ba);
  return {};
}(), lb = b => (lb = Z.free)(b), Pc = b => (Pc = Z.malloc)(b), kb = b => (kb = Z.__getTypeName)(b);
k.dynCall_jiji = (b, a, c, d, e) => (k.dynCall_jiji = Z.dynCall_jiji)(b, a, c, d, e);
k.dynCall_viijii = (b, a, c, d, e, f, m) => (k.dynCall_viijii = Z.dynCall_viijii)(b, a, c, d, e, f, m);
k.dynCall_iiiiij = (b, a, c, d, e, f, m) => (k.dynCall_iiiiij = Z.dynCall_iiiiij)(b, a, c, d, e, f, m);
k.dynCall_iiiiijj = (b, a, c, d, e, f, m, h, l) => (k.dynCall_iiiiijj = Z.dynCall_iiiiijj)(b, a, c, d, e, f, m, h, l);
k.dynCall_iiiiiijj = (b, a, c, d, e, f, m, h, l, n) => (k.dynCall_iiiiiijj = Z.dynCall_iiiiiijj)(b, a, c, d, e, f, m, h, l, n);
var Rc;
Qa = function Sc() {
  Rc || Tc();
  Rc || (Qa = Sc);
};
function Tc() {
  function b() {
    if (!Rc && (Rc = !0, k.calledRun = !0, !Ca)) {
      Ya(La);
      aa(k);
      if (k.onRuntimeInitialized) {
        k.onRuntimeInitialized();
      }
      if (k.postRun) {
        for ("function" == typeof k.postRun && (k.postRun = [k.postRun]); k.postRun.length;) {
          var a = k.postRun.shift();
          Ma.unshift(a);
        }
      }
      Ya(Ma);
    }
  }
  if (!(0 < Oa)) {
    if (k.preRun) {
      for ("function" == typeof k.preRun && (k.preRun = [k.preRun]); k.preRun.length;) {
        Na();
      }
    }
    Ya(Ka);
    0 < Oa || (k.setStatus ? (k.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        k.setStatus("");
      }, 1);
      b();
    }, 1)) : b());
  }
}
if (k.preInit) {
  for ("function" == typeof k.preInit && (k.preInit = [k.preInit]); 0 < k.preInit.length;) {
    k.preInit.pop()();
  }
}
Tc();
moduleRtn = ca;



  return moduleRtn;
}
);
})();
export default Rive;
